module.exports = __webpack_public_path__ + "img/work4.6c386168.jpg";